"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getImageVariantsParams = exports.Image = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _imageSizesHelper = require("@ori/image-sizes-helper");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _api = require("../../../../api");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const getImageVariantsParams = ({
  theme,
  url
}) => ({
  backgroundColor: theme.palette.grey[100],
  imageFormat: 'WebP',
  imageSizeMultiplier: 2,
  params: [{
    width: _styles.IMAGE_SIZE,
    height: _styles.IMAGE_SIZE,
    quality: 90
  }],
  url
});
exports.getImageVariantsParams = getImageVariantsParams;
const Image = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const theme = (0, _mui.useTheme)();
  const {
    productImageUrl,
    productName
  } = (0, _api.useGetReview)();
  if (productImageUrl) {
    const imageVariants = (0, _imageSizesHelper.getImageVariants)(getImageVariantsParams({
      theme,
      url: productImageUrl
    }));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ImageComponent, {
        alt: productName,
        loading: "lazy",
        srcSet: (0, _imageSizesHelper.generateSrcSet)(imageVariants),
        sizes: `${_styles.IMAGE_SIZE}px`,
        src: imageVariants.at(-1)?.url
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Placeholder, {
    "data-testid": getTestId(_constants.IMAGE_PLACEHOLDER),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.Products, {})
  });
};
exports.Image = Image;
